<!-- Top Dynamic Banner Carousel -->
<div *ngIf="activeBanners.length > 0" class="top-banner-carousel position-relative overflow-hidden bg-dark">
  <div class="top-banner-slide position-relative">
    <!-- Imagen del Banner Background -->
    <a *ngIf="activeBanners[currentBannerIndex]?.link" [href]="activeBanners[currentBannerIndex]?.link" target="_blank"
      class="d-block w-100 h-100 position-absolute top-0 start-0">
      <img [src]="resolveImg(activeBanners[currentBannerIndex]?.imageUrl || activeBanners[currentBannerIndex]?.image)"
        [alt]="activeBanners[currentBannerIndex]?.title || 'Promoción Especial'"
        class="top-banner-bg-img w-100 h-100 object-fit-cover" (error)="onImageError($event)">
    </a>
    <img *ngIf="!activeBanners[currentBannerIndex]?.link"
      [src]="resolveImg(activeBanners[currentBannerIndex]?.imageUrl || activeBanners[currentBannerIndex]?.image)"
      [alt]="activeBanners[currentBannerIndex]?.title || 'Promoción Especial'"
      class="top-banner-bg-img w-100 h-100 position-absolute top-0 start-0 object-fit-cover"
      (error)="onImageError($event)">
    <div
      class="top-banner-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-between px-3 px-md-5">
      <button class="top-banner-nav-btn btn btn-sm btn-dark rounded-circle border-0 text-white shadow"
        (click)="prevBanner()" *ngIf="activeBanners.length > 1">
        <i class="fas fa-chevron-left"></i>
      </button>

      <!-- <div class="top-banner-content text-center mx-auto text-white p-3 rounded-4 backdrop-blur-card">
        <span class="announcement-tag mb-2 d-inline-block"><i class="fas fa-bolt me-1"></i>OFERTA DESTACADA</span>
        <h3 class="fw-bold fs-4 m-0 text-white shadow-text">{{ activeBanners[currentBannerIndex]?.title || 'Promoción Exclusiva de Temporada' }}</h3>
        <a *ngIf="activeBanners[currentBannerIndex]?.link" [href]="activeBanners[currentBannerIndex]?.link" target="_blank"
          class="btn btn-sm btn-light rounded-pill px-4 fw-bold mt-2 shadow-sm">
          Ver Promoción <i class="fas fa-arrow-right ms-1"></i>
        </a>
      </div> -->

      <button class="top-banner-nav-btn btn btn-sm btn-dark rounded-circle border-0 text-white shadow"
        (click)="nextBanner()" *ngIf="activeBanners.length > 1">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

    <!-- Indicadores Dots -->
    <div *ngIf="activeBanners.length > 1"
      class="top-banner-dots position-absolute bottom-0 start-50 translate-middle-x mb-2 d-flex gap-2 z-index-3">
      <span *ngFor="let b of activeBanners; let i = index" class="banner-dot" [class.active]="i === currentBannerIndex"
        (click)="setBannerIndex(i)"></span>
    </div>
  </div>
</div>

<!-- Editorial Hero Section (Original) -->
<section class="stitch-hero py-5 position-relative overflow-hidden">
  <div class="container py-lg-4">
    <div class="row align-items-center g-5">

      <!-- Columna Texto Hero -->
      <div class="col-lg-6">
        <div class="hero-text-content">
          <span class="hero-subtitle-badge mb-3">
            <i class="fas fa-sparkles me-2 text-warning"></i> TIENDA MULTICATEGORÍA PREMIA
          </span>
          <h1 class="hero-title mb-4">
            Curaduría Exclusiva para Cada Estilo de Vida
          </h1>
          <p class="hero-description mb-4">
            Seleccionamos cuidadosamente tecnología avanzada, moda contemporánea, artículos para el hogar y cuidado
            personal. Una experiencia de compra superior diseñada para sorprenderte en cada detalle.
          </p>

          <div class="hero-actions d-flex gap-3 flex-wrap align-items-center">
            <button class="btn-stitch-hero-primary" (click)="goToShop()">
              <i class="fas fa-th-large me-2"></i> Explorar Catálogo
            </button>
            <a routerLink="/shop" [queryParams]="{ category: 'Ofertas Flash' }"
              class="btn-stitch-hero-secondary text-decoration-none">
              <i class="fas fa-bolt me-2 text-warning"></i> Ofertas Especiales
            </a>
          </div>
        </div>
      </div>

      <!-- Columna Imagen Hero -->
      <div class="col-lg-6 text-center">
        <div class="hero-image-wrapper position-relative">
          <img src="https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1000&q=80"
            alt="Colección Principal" class="img-fluid hero-main-img shadow-lg">

          <!-- Badge Flotante Minimalista -->
          <div class="floating-luxury-badge shadow-lg d-none d-sm-flex align-items-center gap-3">
            <div class="badge-icon-box">
              <i class="fas fa-star"></i>
            </div>
            <div class="text-start">
              <span class="badge-title">Garantía Oficial</span>
              <span class="badge-sub">Envío Seguro a Colombia</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- Minimal Trust Strip -->
<section class="trust-strip py-4 bg-white border-top border-bottom">
  <div class="container">
    <div class="row g-4 text-center justify-content-center">

      <div class="col-lg-3 col-md-6">
        <div class="trust-strip-item d-flex align-items-center justify-content-center gap-3">
          <div class="trust-icon"><i class="fas fa-truck-fast"></i></div>
          <div class="text-start">
            <h6 class="trust-title m-0">Envíos Nacionales</h6>
            <span class="trust-desc">Despacho seguro en Colombia</span>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="trust-strip-item d-flex align-items-center justify-content-center gap-3">
          <div class="trust-icon"><i class="fas fa-shield-alt"></i></div>
          <div class="text-start">
            <h6 class="trust-title m-0">Garantía Directa</h6>
            <span class="trust-desc">Protección y satisfacción</span>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="trust-strip-item d-flex align-items-center justify-content-center gap-3">
          <div class="trust-icon"><i class="fas fa-lock"></i></div>
          <div class="text-start">
            <h6 class="trust-title m-0">Pago Seguro</h6>
            <span class="trust-desc">Cifrado bancario SSL</span>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="trust-strip-item d-flex align-items-center justify-content-center gap-3">
          <div class="trust-icon"><i class="fas fa-headset"></i></div>
          <div class="text-start">
            <h6 class="trust-title m-0">Atención VIP</h6>
            <span class="trust-desc">Soporte personalizado 24/7</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- Editorial Brand Showcase (Bloque Narrativo & Visual) -->
<section class="editorial-showcase-section py-5">
  <div class="container py-lg-4">
    <div class="row align-items-center g-5">

      <div class="col-lg-6">
        <div class="editorial-card p-4 p-md-5 rounded-4 bg-white border shadow-sm">
          <span class="section-tag mb-2">NUESTRA FILOSOFÍA DE SELECCIÓN</span>
          <h2 class="editorial-title mb-4">La Armonía Entre Funcionalidad & Estética</h2>

          <p class="editorial-paragraph text-muted mb-4">
            En un mundo lleno de opciones, nos enfocamos en lo esencial: productos que combinan durabilidad, tecnología
            de vanguardia y estética refinada. Cada categoría responde a una necesidad real con estándares de
            excelencia.
          </p>

          <div class="editorial-features d-flex flex-column gap-3 mb-4">
            <div class="d-flex align-items-start gap-3">
              <div class="feature-bullet"><i class="fas fa-check-circle text-primary"></i></div>
              <div>
                <strong class="d-block text-dark">Garantía & Verificación</strong>
                <span class="small text-muted">Cada artículo es inspeccionado previamente para garantizar su impecable
                  funcionamiento.</span>
              </div>
            </div>

            <div class="d-flex align-items-start gap-3">
              <div class="feature-bullet"><i class="fas fa-check-circle text-primary"></i></div>
              <div>
                <strong class="d-block text-dark">Variedad Multicategoría</strong>
                <span class="small text-muted">Desde dispositivos electrónicos hasta moda y elementos para el hogar en
                  un solo lugar.</span>
              </div>
            </div>
          </div>

          <button class="btn-stitch-outline" (click)="goToShop()">
            Conoce Nuestras Colecciones <i class="fas fa-arrow-right ms-2"></i>
          </button>
        </div>
      </div>

      <!-- Grilla Visual de Observación Editorial -->
      <div class="col-lg-6">
        <div class="row g-3">
          <div class="col-6">
            <div class="editorial-img-card rounded-4 overflow-hidden mb-3 shadow-sm">
              <img src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=600&q=80"
                alt="Tecnología" class="img-fluid editorial-img">
              <span class="img-caption-badge">Tecnología & Innovación</span>
            </div>
          </div>
          <div class="col-6">
            <div class="editorial-img-card rounded-4 overflow-hidden mt-4 shadow-sm">
              <img src="https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=600&q=80"
                alt="Moda" class="img-fluid editorial-img">
              <span class="img-caption-badge">Moda & Tendencias</span>
            </div>
          </div>
          <div class="col-6">
            <div class="editorial-img-card rounded-4 overflow-hidden shadow-sm">
              <img src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&w=600&q=80"
                alt="Hogar" class="img-fluid editorial-img">
              <span class="img-caption-badge">Hogar & Espacios</span>
            </div>
          </div>
          <div class="col-6">
            <div class="editorial-img-card rounded-4 overflow-hidden mt-4 shadow-sm">
              <img src="https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?auto=format&fit=crop&w=600&q=80"
                alt="Belleza" class="img-fluid editorial-img">
              <span class="img-caption-badge">Belleza & Bienestar</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- Categorías / Universo de Productos -->
<section class="categories-section py-5 bg-light-subtle border-top">
  <div class="container py-lg-3">
    <div class="section-title-box text-center mb-5">
      <span class="section-tag mb-2">UNIVERSO DE PRODUCTOS</span>
      <h2 class="section-heading">Explora por Categoría</h2>
      <p class="text-muted mx-auto max-width-500">Colecciones organizadas para facilitar tu experiencia de compra</p>
      <div class="title-underline mx-auto mt-2"></div>
    </div>

    <div class="row g-4">
      <div class="col-lg-3 col-md-6" *ngFor="let category of categories">
        <div class="luxury-category-card overflow-hidden rounded-4 position-relative" (click)="goToCategory(category)">
          <div class="category-image-box">
            <img [src]="category.img" [alt]="category.name" class="img-fluid category-bg-img"
              (error)="onImageError($event)">
            <div class="category-overlay"></div>
          </div>
          <div
            class="category-card-content p-4 d-flex flex-column justify-content-end text-white position-absolute w-100 h-100 top-0 start-0">
            <span class="cat-tag mb-1">Categoría</span>
            <h4 class="cat-name fw-bold mb-1">{{ category.name }}</h4>
            <p class="cat-subtitle small text-slate-300 mb-3 d-none d-sm-block">{{ category.subtitle }}</p>
            <span class="cat-btn-link d-inline-flex align-items-center gap-2 fw-semibold">
              Ver Colección <i class="fas fa-arrow-right small"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Productos Más Vendidos / Selección VIP -->
<section class="featured-products-section py-5 bg-white border-top">
  <div class="container py-lg-3">

    <div class="d-flex flex-wrap justify-content-between align-items-end mb-5 gap-3">
      <div>
        <span class="section-tag mb-2">SELECCIÓN DESTACADA</span>
        <h2 class="section-heading m-0">Lo Más Deseado</h2>
      </div>
      <button class="btn-stitch-outline" (click)="goToShop()">
        Ver Catálogo Completo <i class="fas fa-arrow-right ms-2"></i>
      </button>
    </div>

    <div class="row g-4">
      <div class="col-lg-3 col-md-4 col-sm-6" *ngFor="let product of products">
        <div
          class="luxury-product-card bg-white rounded-4 border overflow-hidden h-100 d-flex flex-column cursor-pointer"
          (click)="openProductModal(product)">

          <!-- Contenedor Imagen -->
          <div
            class="product-img-box position-relative p-4 text-center bg-light-subtle d-flex align-items-center justify-content-center">
            <span class="luxury-discount-pill position-absolute top-0 start-0 m-3"
              *ngIf="product.discountPercentage || product.hasDiscount">
              -{{ product.discountPercentage || 20 }}%
            </span>
            <span class="badge bg-warning text-dark position-absolute top-0 end-0 m-3 shadow-sm font-weight-bold"
              *ngIf="product.isFeatured || product.isOutstanding || product.outstanding">
              <i class="fas fa-star me-1"></i>Destacado
            </span>
            <img [src]="resolveImg(product.image || product.imageUrl)" [alt]="product.name"
              class="img-fluid product-img">
          </div>

          <!-- Cuerpo Detalle -->
          <div class="product-body p-4 d-flex flex-column flex-grow-1">
            <span class="product-cat-label text-uppercase mb-1">{{ product.category || 'Destacado' }}</span>
            <h5 class="product-name fw-bold text-dark mb-3 line-clamp-2">{{ product.name }}</h5>

            <div class="product-footer mt-auto pt-3 border-top d-flex align-items-center justify-content-between">
              <div>
                <span class="price-label d-block text-muted">Precio</span>
                <span class="price-value fw-bold text-dark">${{ product.price | number }} COP</span>
              </div>
              <button class="btn-product-add rounded-circle d-flex align-items-center justify-content-center"
                title="Añadir al Carrito">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</section>

<!-- Testimonios VIP -->
<section class="testimonials-section py-5 bg-light-subtle border-top">
  <div class="container py-lg-3">
    <div class="section-title-box text-center mb-5">
      <span class="section-tag mb-2">EXPERIENCIA COMPROBADA</span>
      <h2 class="section-heading">Opiniones de Nuestros Clientes</h2>
      <div class="title-underline mx-auto mt-2"></div>
    </div>

    <div class="row g-4">
      <div class="col-md-4" *ngFor="let t of testimonials.slice(0, 3)">
        <div class="luxury-testimonial-card p-4 bg-white rounded-4 border shadow-sm h-100 d-flex flex-column">
          <div class="d-flex align-items-center gap-3 mb-3">
            <img [src]="t.photo" [alt]="t.name" class="testimonial-avatar rounded-circle border"
              (error)="onImageError($event)">
            <div>
              <h6 class="fw-bold m-0 text-dark">{{ t.name }}</h6>
              <span class="small text-emerald d-flex align-items-center gap-1">
                <i class="fas fa-check-circle"></i> Comprador Verificado
              </span>
            </div>
          </div>
          <div class="star-rating mb-3 text-warning">
            <i class="fas fa-star" *ngFor="let star of [1,2,3,4,5]"></i>
          </div>
          <p class="testimonial-quote text-muted m-0">"{{ t.comment }}"</p>
        </div>
      </div>
    </div>

  </div>
</section>



<!-- Newsletter VIP (Dark Slate Accent) -->
<section class="luxury-newsletter-section py-5 text-white">
  <div class="container text-center py-lg-3">
    <div class="newsletter-card-box mx-auto p-4 p-md-5 rounded-4">
      <span class="section-tag text-cyan mb-2">COMUNIDAD EXCLUSIVA</span>
      <h3 class="fw-bold text-white mb-3">Únete a Nuestro Club VIP</h3>
      <p class="text-slate-300 mb-4 mx-auto max-width-500">
        Recibe promociones privadas, acceso anticipado a nuevas colecciones y atención prioritaria.
      </p>

      <form (submit)="subscribe()"
        class="d-flex flex-column flex-sm-row justify-content-center gap-2 max-width-500 mx-auto">
        <input type="email" class="form-control form-control-lg luxury-newsletter-input"
          placeholder="Tu correo electrónico..." [(ngModel)]="email" name="email" required>
        <button type="submit" class="btn-stitch-hero-primary px-4 py-3 flex-shrink-0">
          Suscribirme
        </button>
      </form>
    </div>
  </div>
</section>

<!-- Modal de Selección de Producto Glassmorphism -->
<div *ngIf="isModalOpen" class="modal-overlay d-flex align-items-center justify-content-center p-3">
  <div class="modal-card p-4 bg-white rounded-4 shadow-lg border">
    <div class="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
      <h4 class="fw-bold m-0 text-dark">{{ modalProduct?.name }}</h4>
      <button class="btn-close border-0 bg-transparent fs-4 text-muted" (click)="closeModal()">&times;</button>
    </div>

    <img *ngIf="modalProduct" [src]="resolveImg(modalProduct.image || modalProduct.imageUrl)" [alt]="modalProduct.name"
      class="img-fluid rounded-3 mb-3 modal-prod-img">

    <div class="modal-section mb-4" *ngIf="modalAvailableSizes && modalAvailableSizes.length > 0">
      <label class="fw-bold mb-2 text-dark small text-uppercase">Selecciona Opciones / Talla:</label>
      <div class="d-flex gap-2 flex-wrap">
        <button *ngFor="let size of modalAvailableSizes" class="btn btn-outline-primary btn-sm rounded-3 px-3"
          [class.active]="modalSelectedSize === size.valor" (click)="selectSize(size)">
          {{ size.valor }}
        </button>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
      <button class="btn btn-light rounded-3 px-4 font-weight-bold text-muted" (click)="closeModal()">Cancelar</button>
      <button class="btn-stitch-hero-primary px-4 py-2" (click)="confirmSelection()">Añadir al Carrito</button>
    </div>
  </div>
</div>